var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailSignupRight = function SvgEmailSignupRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 149,
    viewBox: "0 0 135 149",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.549 105.607h6.694v-9.374l15.943-14.252 15.946 14.252v9.374h6.694V93.24L132.186 73l-22.637 20.24v12.367zM109.545 110.515h45.281v6.721h-45.281v-6.721zM.003 9.2h5.296v7.418l12.614 11.276 12.616-11.276V9.2h5.297v9.785L17.913 35 .003 18.986V9.2zM0 5.318h35.826V0H0v5.318zM35.824 139.799h-5.297v-7.417l-12.614-11.276-12.616 11.276v7.417H0v-9.785L17.913 114l17.91 16.014v9.785zM35.826 143.682H0V149h35.826v-5.318z"
  })));
};
export default SvgEmailSignupRight;